

export const CAPTCHA = '6LelNNghAAAAAP8mdcIC_XUzSQBSK8e1tlonP65-'
